import { render, staticRenderFns } from "./Filetype.vue?vue&type=template&id=3f1668a2"
import script from "./Filetype.vue?vue&type=script&lang=js"
export * from "./Filetype.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports